import { BigNum, PRICE_PRECISION_EXP } from '@drift-labs/sdk';
import { USDC_SPOT_MARKET_INDEX } from '@drift/common';

const USDT_SPOT_MARKET_INDEX = 5;

/**
 * Get the price to use for deposit validation.
 * For USDC and USDT, always returns exactly $1 to avoid validation failures
 * due to oracle price fluctuations (e.g., USDC oracle at $0.9998 causing 10 USDC to fail $10 minimum).
 * For other assets, returns the oracle price.
 */
export function getDepositValidationPrice(
	marketIndex: number,
	oraclePrice: BigNum
): BigNum {
	if (
		marketIndex === USDC_SPOT_MARKET_INDEX ||
		marketIndex === USDT_SPOT_MARKET_INDEX
	) {
		return BigNum.fromPrint('1', PRICE_PRECISION_EXP);
	}

	return oraclePrice;
}
